import classNames from 'classnames';
import { FC, HTMLAttributes } from 'react';

import './index.scss';

export interface IContainerProps {
    classNamesContainer?: string;
}

export type ContainerProps = IContainerProps & HTMLAttributes<HTMLDivElement>;

const Container: FC<ContainerProps> = ({ children, classNamesContainer, ...rest }) => (
    <div className={classNames('main-container', classNamesContainer)} {...rest}>
        {children}
    </div>
);

export default Container;
